import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  store,
} from './store/store';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import OrderBooth from './router/OrderBooth.vue';
// import ChoixPerso from './router/ChoixPerso.vue';
import Options from './router/Options.vue';
import Booths from './router/Booths.vue';
import PaymentLink from './router/PaymentLink';
import NoRoute from './router/NoRoute.vue';
import titleMixin from './titleMixin';

Vue.mixin(titleMixin);

Vue.use(VueRouter);

Vue.config.productionTip = false;

const routes = [
  {
    name: 'OrderBooth',
    path: '/',
    component: OrderBooth,
  },
  // {
  //   name: 'ChoixPerso',
  //   path: '/Choix_personnalisation',
  //   component: ChoixPerso,
  // },
  {
    name: 'Options',
    path: '/Options',
    component: Options,
  },
  {
    name: 'Booths',
    path: '/Booths',
    component: Booths,
  },
  {
    name: 'PaymentLink',
    path: '/PaymentLink',
    component: PaymentLink,
  },
  {
    name: 'NoRoute',
    path: '*',
    component: NoRoute,
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes: routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.adminOnly)) {
    if (store.getters.auth.role === 'ADMINISTRATOR') {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

new Vue(Vue.util.extend({
  store,
  router,
}, App)).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js